import Service from "../../Service";

const resource = "visit/";

export default {
    find(VstID, requestID) {
        return Service.post(resource + "find", {}, {
            params: {
                VstID: VstID,
                requestID: requestID,
            },
        });
    },
    save(parameters, requestID) {
        return Service.post(resource + "save", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID }
        });
    },
    getVisitFarmLot(parameters, requestID) {
        return Service.post(resource + "getVisitFarmLot", parameters, {
            params: { requestID }
        });
    },

    tecnicalreportpdf(parameters, requestID) {
        return Service.post(resource + "tecnicalreportpdf", parameters, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID }
        });
    },

    graphvisit(parameters, requestID) {
        return Service.post(resource + "graphvisit", parameters, {
            params: { requestID }
        });
    },

    graphvisitevaluation(parameters, requestID) {
        return Service.post(resource + "graphvisitevaluation", parameters, {
            params: { requestID }
        });
    },

    reportAll(parameters, requestID) {
        return Service.post(resource + "reportAll", parameters, {
            params: { requestID }
        });
    },
    visitFind(VstID, requestID) {
        return Service.post(resource + "visitFind", {}, {
            params: {
                VstID: VstID,
                requestID: requestID,
            },
        });
    },
    findById(VstID, requestID) {
        return Service.post(resource + "TasVisit_ById", { VstID }, {
            params: { VstID, requestID },
        });
    },
    listTasVisitPerformedActivitiesHistoricalReport(FltID, CmaID, requestID) {
        return Service.get(resource + "listTasVisitPerformedActivitiesHistoricalReport", {
            params: { FltID: FltID, CmaID: CmaID, requestID: requestID }
        });
    },
    listTasVisitPhytosanitaryEvaluationHistoricalReport(FltID, CmaID, requestID) {
        return Service.get(resource + "listTasVisitPhytosanitaryEvaluationHistoricalReport", {
            params: { FltID: FltID, CmaID: CmaID, requestID: requestID }
        });
    },
    listTasVisitRecomendationHistoricalReport(FltID, CmaID, requestID) {
        return Service.get(resource + "listTasVisitRecomendationHistoricalReport", {
            params: { FltID: FltID, CmaID: CmaID, requestID: requestID }
        });
    },

    TasVisitPerformedApplicatioPdf(CmaID, FltID, requestID) {
        return Service.post(resource + "TasVisitPerformedApplicatioPdf", {}, {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                requestID: requestID,
            }
        });
    },
    TasVisitPerformedApplicationFertiPdf(CmaID, FltID, requestID) {
        return Service.post(resource + "TasVisitPerformedApplicationFertiPdf", {}, {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                requestID: requestID,
            }
        });
    },
    TasVisitPerformedActivitiesPodaPdf(CmaID, FltID, requestID) {
        return Service.post(resource + "TasVisitPerformedActivitiesPodaPdf", {}, {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                requestID: requestID,
            }
        });
    },
    TasVisitPerformedActivitiesRiegoPdf(CmaID, FltID, requestID) {
        return Service.post(resource + "TasVisitPerformedActivitiesRiegoPdf", {}, {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                requestID: requestID,
            }
        });
    },
    TasVisitPerformedActivitiesPdf(CmaID, FltID, requestID) {
        return Service.post(resource + "TasVisitPerformedActivitiesPdf", {}, {
            params: {
                CmaID: CmaID,
                FltID: FltID,
                requestID: requestID,
            }
        });
    },
    TasVisitPerformedApplicationReal(parameters, requestID) {
        return Service.post(resource + "TasVisitPerformedApplicationReal", parameters, {
            params: {
                requestID: requestID,
            }
        });
    },
};